<header class="flex header">
  <h2>
    @if (stepValues.controls.length) {
      {{ 'Step_Values_Edit' | translateWF: 'Edit Step Values' }}
    } @else {
      {{ 'Step_Values_Add' | translateWF: 'Add Step Values' }}
    }
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <div *ngFor="let formValue of stepValues.controls; let i = index" class="flex value">
    <div class="form-box">
      <label for="value{{ i }}">Value {{ i + 1 }}</label>
      <div class="flex">
        <input id="value{{ i }}" type="text" [formControl]="formValue" pInputText class="w-full" [disabled]="!canEdit" />
        @if (canEdit) {
          <p-button icon="pi pi-trash" (click)="removeValue(i)" />
        }
      </div>
      <p *ngIf="formValue.errors" class="error">
        {{ getParameterTypeErrorMessage(formValue) }}
      </p>
    </div>
  </div>

  @if (canEdit) {
    <p-button label="Add Value" icon="pi pi-plus" variant="outlined" (click)="addValue()" />
  }
</section>

<footer>
  @if (canEdit) {
    <p-button class="w-full" label="Save" [disabled]="stepValues.invalid" (click)="onSave()" />
  }
  <p-button class="w-full" label="Cancel" variant="outlined" (click)="onClose()" />
</footer>
